import { render } from "./EventTicketResume.vue?vue&type=template&id=0f10580e&scoped=true&ts=true"
import script from "./EventTicketResume.vue?vue&type=script&lang=ts"
export * from "./EventTicketResume.vue?vue&type=script&lang=ts"

import "./EventTicketResume.vue?vue&type=style&index=0&id=0f10580e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f10580e"]])

export default __exports__